/**
 * App-wide react-query retry policy, applied to every query and mutation in App.tsx. Lives here
 * so tests exercise the real predicate rather than a copy that drifts.
 */

/**
 * Retries transient failures — a 5xx, or an error with no `statusCode` (never reached the
 * server). Up to 3 retries, 4 attempts total.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const retry = (failureCount: number, error: any) =>
  failureCount < 3 && (!error.statusCode || String(error.statusCode).startsWith('5'));

/**
 * query-core passes the pre-increment failure count, so the floor always wins: every wait is
 * 2000ms in practice.
 */
export const retryDelay = (failureCount: number) => Math.max(500 * failureCount, 2000);
